export default {
  quote: {},
};
